// This file is automatically generated during the build process based on the version in the package.json
export const APP_VERSION = '1.10.0';
export const APP_VERSION_DATE = '2026-04-17'